import { useState, useCallback } from "react";
import AppSnackbar from "../components/AppSnackbar/AppSnackbar";

const useAppSnackbar = () => {
    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const showSnackbar = useCallback((message, severity) => {
        setSnackbarState({
            open: true,
            message,
            severity,
        });
    }, []);

    const handleClose = useCallback(() => {
        setSnackbarState((prev) => ({ ...prev, open: false }));
    }, []);

    const showSuccess = useCallback((message) => {
        showSnackbar(message, "success");
    }, [showSnackbar]);

    const showError = useCallback((message) => {
        showSnackbar(message, "error");
    }, [showSnackbar]);

    const showInfo = useCallback((message) => {
        showSnackbar(message, "info");
    }, [showSnackbar]);

    const showWarning = useCallback((message) => {
        showSnackbar(message, "warning");
    }, [showSnackbar]);

    const SnackbarComponent = useCallback(() => (
        <AppSnackbar
            open={snackbarState.open}
            message={snackbarState.message}
            severity={snackbarState.severity}
            onClose={handleClose}
        />
    ), [snackbarState, handleClose]);

    return {
        showSuccess,
        showError,
        showInfo,
        showWarning,
        SnackbarComponent,
    };
};

export default useAppSnackbar;